<jhi-modal title="{{ 'study-editor.import-crosses.import-file.title' | translate }}" [disabled]="isSaving">
	<div class="modal-body">
		<div class="row pt-2">
			<div class="col"><span class="fw-bold">{{ 'study-editor.import-crosses.import-file.heading' | translate | uppercase}}</span></div>
		</div>
		<div class="row pt-2">
			<div class="col">
				<span>{{ 'study-editor.import-crosses.import-file.description' | translate}}</span>
			</div>
		</div>
		<div class="row pt-3">
			<div class="col-8">
				<jhi-file-select id="file"
								 [acceptedFileTypes]="selectedFormat?.extension"
								 (fileSelected)="handleFileChange($event)"
								 (fileCleared)="clearSelectedFile()">
				</jhi-file-select>
			</div>
		</div>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="cancel()" [disabled]="isSaving">
			<span translate="cancel"></span>
		</button>
		<button (click)="continue($event)" class="btn btn-primary" [disabled]="isSaving || !rawData">
			<span *ngIf="isSaving" class="throbber throbber-btn"></span>
			<span translate="continue"></span>
		</button>
	</div>
</jhi-modal>
